/**
 * Generated runtime TestId mirror for frontend/src/components/auto-assign/TriggerFullEvaluationButton.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const TriggerFullEvaluationButtonTestIds = {
  btnTriggerFullEvaluation: "btn-trigger-full-evaluation",
  btnTriggerFullEvaluationCancel: "btn-trigger-full-evaluation-cancel",
  btnTriggerFullEvaluationConfirm: "btn-trigger-full-evaluation-confirm",
  triggerFullEvaluationDialog: "trigger-full-evaluation-dialog"
} as const;
